import {logger, getDomPath} from '@/scripts/utils'
import Vue from 'vue'

Vue.mixin({
    methods: {
        log_info: msg => logger.info(msg),
        log_debug: msg => logger.debug(msg),
        log_warning: msg => logger.warning(msg),
        log_error: msg => logger.error(msg),
        log_exception: msg => logger.exception(msg),
        log_critical: msg => logger.critical(msg)
    }
})

// window.addEventListener("error", function (e) {
//     logger.exception('Unhandled exception', e.error).catch(e => console.log(`Error: logging call failed`))
//     return false;
// })
// window.addEventListener('unhandledrejection', function (e) {
//     logger.error(`Unhandled promise exception (promise: ${e.promise}, reason: ${e.reason}')`).catch(e => console.log(`Error: logging call failed`))
// });

// Vue.config.errorHandler = function (err, vm, info) {
//     let domPath = 'unknown dom path'
//     try {
//         domPath = getDomPath(vm.$el).join(' => ')
//     } catch (e) {
//     }
//
//     logger.exception(`Unhandled Vue exception (${info} in ${domPath})`, err).catch(e => console.log(`Error: logging call failed`))
//     throw err
// }